import React from 'react'
import { useHistory } from 'react-router-dom'
import { Modal } from '@commutifi-fe/ui'
import { FormattedMessage } from 'locales/index'
import { useModal } from '@commutifi-fe/hooks'
import { PublicRouting } from 'src/routing'

export const useMissingInformationModal = () => {
  const history = useHistory()

  const { openedId, openModal, closeModal } = useModal<{ redirectPath: string }>()

  const handleRedirectToSurvey = React.useCallback<React.MouseEventHandler>(
    (e) => {
      e.preventDefault()
      const metadata = closeModal()
      if (metadata) {
        history.push(metadata.redirectPath)
      }
    },
    [closeModal, history]
  )

  const openMissingInfoModal = React.useCallback(
    (_metadata: { redirectPath: string }) => {
      openModal('missing_account_modal', _metadata)
    },
    [openModal]
  )

  const handleCancel: React.MouseEventHandler = React.useCallback(
    (e) => {
      e.preventDefault()
      closeModal()
      history.replace(PublicRouting.auth.path)
    },
    [closeModal, history]
  )

  const value = React.useMemo(
    () => ({
      renderModal: () => (
        <Modal
          title={<FormattedMessage id="auth.incompleteAccount.modal.title" />}
          open={openedId === 'missing_account_modal'}
          onCancel={handleCancel}
          onOk={handleRedirectToSurvey}
          okText={<FormattedMessage id="auth.incompleteAccount.button.nextStep" />}
        >
          <FormattedMessage id="auth.incompleteAccount.modal.description" />
        </Modal>
      ),
      openModal: openMissingInfoModal
    }),
    [handleCancel, handleRedirectToSurvey, openMissingInfoModal, openedId]
  )

  return value
}
